import { useEffect, useContext } from "react";
import { OaRVaRChartConfig } from "./OaRVaRChartConfig";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { Loader } from "../../../components/loader/Loader";

export const OaRChart = () => {
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);

  const { oarvar, filter, oarFiltered } = lstore;

  useEffect(() => {
    if (oarvar && oarvar.rawdata.length > 0) {
      
      const fdata = oarvar.rawdata
        .filter((row) => {
          return (
            filter["ModelDate"].includes(row["ModelDate"]) &&
            filter["Ticker"].includes(row["Ticker"]) &&
            filter["Horizon"].includes(row["Horizon"]) &&
            filter["RiskModel"].includes(row["RiskModel"]) &&
            filter[" Pctile "].includes(row[" Pctile "]) &&
            row["OaR"]
          );
        })
        .map((item) => {
          return {
            ...item,
            "V-Score": +item["V-Score"],
            OaR:
              item["RiskModel"] === "Sigma"
                ? +item["OaR"].split("%").join("") 
                : +item["OaR"].split("%").join(""),
          };
        });

      ldispatch({ type: lactionTypes.SET_OaR_FILTERED, payload: fdata });
    }
  }, [oarvar, ldispatch, filter]);

  return  oarFiltered ? (
    <OaRVaRChartConfig
      data={oarFiltered}
      width={refs.componentSize.current["OaRChart"].width}
      height={refs.componentSize.current["OaRChart"].height}
      lRef={refs.oar}
      palette={refs.tickerPalette.current}
      selection="OaR"
    />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
